"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: "ShowStep",
    props: {
        current: {
            type: Number,
            required: true
        }
    }
};
